/**
 * Where the Operating Scan application lives.
 *
 * The application will move to diagnostic.ajility.com.au, a subdomain of this
 * root domain. Until the hosting change is made, SCAN_APP_URL points at the
 * temporary external host. When the subdomain is live, set SCAN_APP_URL to
 * DIAGNOSTIC_SUBDOMAIN and nothing else needs to change: every page links to
 * the on-domain /scan route, not to the application directly.
 */
export const DIAGNOSTIC_SUBDOMAIN = "https://diagnostic.ajility.com.au";

export const SCAN_APP_URL = "https://diagnostic.ajility.com.au";

/** True once the application is served from our own subdomain. */
export const SCAN_APP_ON_DOMAIN = true;

/** Single source for how the free Operating Scan is described. */
export const SCAN_QUESTION_COUNT = 21;
export const SCAN_DURATION_MINUTES = 6;
export const SCAN_DESCRIPTION =
  "21 plain statements about how the business actually runs, answered from Not us to Always. About six minutes, then a provisional score naming the weakest areas and a conversation if you want one.";

/**
 * The one place the outbound Operating Scan URL is built. `start=scan` tells
 * the application to open statement 1 directly, skipping its own landing step.
 */
export function scanUrl(placement: string): string {
  const url = new URL(SCAN_APP_URL);
  url.searchParams.set("utm_source", "ajility_site");
  url.searchParams.set("utm_medium", "referral");
  url.searchParams.set("utm_campaign", "operating_scan");
  url.searchParams.set("utm_content", placement);
  url.searchParams.set("start", "scan");
  return url.toString();
}
